import Spotify from 'spotify-web-api-js';
export const SpotifyClient = new Spotify();
